export const translations = {
  en: {
    navbar: {
      logo: 'Gursikh Sabha Cancun',
      links: ['Vision', 'Support', 'Partner', 'FAQ'],
      donateCta: 'Book your Anand Karaj'},
    hero: {
      headline1: 'A Gurdwara for Cancun.',
      headline2: 'A Legacy for Generations.',
      subheadline:
        'As Punjabi destination weddings flourish across Mexico, Cancun needs a true spiritual home — a gurdwara to serve families, support sacred ceremonies, welcome travelers, and become a lasting center of sangat, seva, and community.',
      cta1: 'Book your Anand Karaj in Cancun',
      cta2: 'Become a Founding Supporter',
      scrollIndicator: 'Discover'},
    theNeed: {
      title1: 'The Need Is Real.',
      title2: 'The Moment Is Now.',
      description:
        'While Cancun has become a premier destination for Punjabi weddings and family travel, it lacks the essential spiritual infrastructure. Couples, parents, and grandparents need a trusted place for prayer, Anand Karaj ceremonies, and community support. This is a critical gap we must fill.',
      imageCaption:
        'The Anand Karaj Center features a grand, covered exterior entrance specifically designed to accommodate traditional wedding Baraats. The spacious layout ensures families can celebrate joyously while maintaining a dignified and respectful environment before entering the sacred space.',
      stats: [
        { number: '250–500', label: 'Punjabi Destination Weddings Annually' },
        { number: 'Zero', label: 'Dedicated Gurdwaras in Cancun Today' },
        { number: 'Global', label: 'Sikh Family Demand Growing Rapidly' }]},
    whyCancun: {
      title: 'Why Cancun?',
      description:
        'Cancun is more than just a beautiful location; it is a strategic crossroads. As thousands of Sikh families travel here annually for celebrations and vacations, establishing a gurdwara here ensures that our spiritual roots travel with us, providing a sanctuary of peace and tradition away from home.',
      points: [
        {
          title: 'Premier Destination Hub',
          desc: 'The epicenter of destination weddings in the Americas.'},
        {
          title: 'International Accessibility',
          desc: 'Direct flights from major hubs in Canada, USA, and globally.'},
        {
          title: 'World-Class Infrastructure',
          desc: 'Unmatched hospitality ecosystem ready to support large events.'},
        {
          title: 'Natural Anchor Point',
          desc: 'A strategic location to establish a lasting Sikh spiritual presence.'},
        {
          title: 'An Iconic Opportunity',
          desc: 'The chance to build a landmark that blends sacred tradition with tropical elegance.'}]},
    ourVision: {
      title: 'Our Vision',
      subtitle: 'Building in Phases. Growing with Purpose.',
      phases: [
        {
          num: '01',
          title: 'Establish',
          desc: 'Lease a dedicated unit to immediately begin serving the community with daily prayer, Anand Karaj support, and a welcoming space for travelers.'},
        {
          num: '02',
          title: 'Grow',
          desc: 'Build out a beautiful, fully operational gurdwara home, expanding our capacity for hospitality, langar, and larger community gatherings.'},
        {
          num: '03',
          title: 'Landmark',
          desc: 'Establish a permanent, best-in-class architectural landmark in Cancun that will stand as a beacon of Sikh heritage for generations.'}]},
    globalNetwork: {
      title1: 'Supported by a',
      title2: 'Global Network',
      description:
        'This initiative is backed by respected Sikh families, experienced gurdwara builders, hospitality professionals, and destination wedding experts from around the world.',
      noteHighlight: 'Important:',
      note: 'Committed capital is already in place. Community support is needed to bring this vision fully to life and ensure its long-term sustainability.',
      locations: ['Singapore', 'India', 'Canada', 'New York', 'and beyond']},
    weddingEcosystem: {
      eyebrow: 'For the Wedding Ecosystem',
      title: 'A Strategic Partnership Opportunity',
      imageCaption:
        'The Anand Karaj Center features a grand, covered exterior entrance specifically designed to accommodate traditional wedding Baraats. The spacious layout ensures families can celebrate joyously while maintaining a dignified and respectful environment before entering the sacred space.',
      description:
        'We are calling on destination wedding planners, hospitality professionals, and industry leaders to join us. By partnering with the Cancun Gurdwara, you help ensure your clients have access to a trusted ceremony venue, family hospitality, and the spiritual infrastructure they need for a perfect Anand Karaj.',
      plannerNote:
        'Join leading planners who are already supporting this historic initiative.',
      cta: 'Book the Gurdwara'},
    weddingDateInquiry: {
      title: 'Planning Your Destination Wedding?',
      subtitle:
        'Check availability and find out if the Cancun Gurdwara can support your special day.',
      description:
        'Whether you are planning an Anand Karaj in Cancun or exploring destination wedding options, reach out to our team directly. We will help you understand timelines, availability, and how we can support your family.',
      cta: 'Contact Us'},
    whatThisMakesPossible: {
      title1: 'What This Makes',
      title2: 'Possible',
      features: [
        {
          title: 'Anand Karaj Support',
          desc: 'A dedicated, sacred space for destination weddings.'},
        {
          title: 'Daily Prayer & Sangat',
          desc: 'Consistent spiritual access for locals and travelers alike.'},
        {
          title: 'Family Hospitality',
          desc: 'A welcoming environment rooted in the tradition of langar.'},
        {
          title: 'Elder & Traveler Welcome',
          desc: 'A sense of home and comfort for visiting families.'},
        {
          title: 'Trusted Infrastructure',
          desc: 'Reliable support for complex destination events.'},
        {
          title: 'A Landmark for Generations',
          desc: 'Building a legacy of Sikh presence in the Americas.'}]},
    fundingPathways: {
      title: 'Support the Cancun Gurdwara',
      subtitle:
        'Every contribution brings this historic vision closer to reality. Choose your pathway to support.',
      donateFrom: 'Donate from',
      comingSoon: 'Link Coming Soon',
      opportunities: [
        'Founding Donor Opportunities',
        'Family Sponsorship',
        'Corporate / Hospitality Supporters'],
      inquireCta: 'Inquire Now'},
    foundingCircle: {
      title1: 'Join the',
      title2: 'Founding Circle',
      description:
        'This is a once-in-a-generation opportunity to help create a spiritual home that will serve families for decades to come. Your name. Your family. Part of history.',
      cta: 'Become a Founding Supporter'},
    faq: {
      title: 'Frequently Asked Questions',
      questions: [
        {
          q: 'Where will the Gurdwara be located?',
          a: 'We are evaluating several central locations in Cancun that offer easy access from the hotel zone and airport.'},
        {
          q: 'When will it open?',
          a: 'Phase 1 (Establish) is targeted for late 2024, providing immediate support for Anand Karaj ceremonies.'},
        {
          q: 'How can I book an Anand Karaj?',
          a: 'Please use the inquiry form above to check dates and availability with our team.'}]},
    stickyMobileCta: {
      text: 'Book your Anand Karaj'},
    finalCta: {
      headline1: 'A Legacy for',
      headline2: 'Generations.',
      cta1: 'Book your Anand Karaj',
      cta2: 'Become a Founding Supporter',
      copyright: '© 2024 Gursikh Sabha Cancun. All rights reserved.',
      pitchDeck: 'Pitch Deck',
      contact: 'Contact',
      inquiries: 'Inquiries',
      privacy: 'Privacy'},
    pitchDeck: {
      backToHome: 'Back to Home',
      cover: {
        title: 'Gursikh Sabha Cancun',
        subtitle: "Building Cancun's First Gurdwara",
        description:
          "A strategic initiative to establish a lasting spiritual home for the global Sikh community in the Americas' premier destination hub."},
      sacredNeed: {
        title: 'The Sacred Need',
        subtitle: 'Restoring Satkaar (Respect) for Guru Granth Sahib Ji',
        description:
          'Currently, Anand Karaj ceremonies in Cancun take place in hotel ballrooms and resorts. Without a dedicated spiritual space, maintaining the highest level of Maryada (code of conduct) and Satkaar for Guru Granth Sahib Ji is a constant challenge. We need a pure, dedicated sanctuary where Maharaj can be seated with the absolute respect our faith demands.'},
      opportunity: {
        title: 'The Opportunity',
        description:
          'Cancun has rapidly become a premier destination for Punjabi weddings and family travel, yet it lacks essential spiritual infrastructure. This presents a unique opportunity to build a landmark institution.',
        stats: [
          { number: '250–500', label: 'Punjabi Destination Weddings Annually' },
          { number: 'Zero', label: 'Dedicated Gurdwaras in Cancun Today' },
          { number: 'Global', label: 'Sikh Family Demand Growing Rapidly' }]},
      whyCancun: {
        title: 'Why Cancun?',
        points: [
          {
            title: 'Premier Destination Hub',
            desc: 'The epicenter of destination weddings in the Americas.'},
          {
            title: 'International Accessibility',
            desc: 'Direct flights from major hubs globally.'},
          {
            title: 'World-Class Infrastructure',
            desc: 'Unmatched hospitality ecosystem.'},
          {
            title: 'Strategic Location',
            desc: 'A natural anchor point for a lasting Sikh presence.'}]},
      reality: {
        title: 'The Reality',
        subtitle: 'A Diaspora-Funded Mission',
        description:
          'There is no established local Sikh community in Cancun or Mexico to fund and sustain this Gurdwara. We rely 100% on the American and Canadian diaspora. If we want our families and future generations to have a proper Anand Karaj in Cancun, we—the diaspora—must build it ourselves.'},
      vision: {
        title: 'Our Vision',
        subtitle: 'Building in Phases. Growing with Purpose.',
        phases: [
          {
            num: '01',
            title: 'Establish',
            desc: 'Lease a dedicated space for daily prayer and Anand Karaj.'},
          {
            num: '02',
            title: 'Grow',
            desc: 'Build out a fully operational gurdwara with langar facilities.'},
          {
            num: '03',
            title: 'Landmark',
            desc: 'Establish a permanent architectural landmark in Cancun.'}]},
      ecosystem: {
        title: 'The Wedding Ecosystem',
        description:
          "The gurdwara will become a vital part of Cancun's booming destination wedding market, working seamlessly alongside planners, resorts, and vendors to provide authentic spiritual infrastructure for Sikh families."},
      network: {
        title: 'Global Network',
        description:
          'Backed by a coalition of respected families, experienced builders, and hospitality professionals from around the world.',
        locations: ['Singapore', 'India', 'Canada', 'New York', 'and beyond']},
      financial: {
        title: 'The Financial Ask',
        description:
          'Initial capital has been committed by our founding group. We are now seeking broader community support from across North America to secure our lease, fund Phase 1 operations, and ensure long-term sustainability.',
        tiers: [
          {
            title: 'Founding Circle',
            desc: 'Major benefactors shaping the foundation.'},
          {
            title: 'Family Sponsorships',
            desc: 'Sponsoring specific facilities or programs.'},
          {
            title: 'Corporate Supporters',
            desc: 'Partnerships with hospitality and wedding vendors.'}]},
      cta: {
        title: 'Join Us',
        donate: 'Book your Anand Karaj',
        founding: 'Become a Founding Supporter',
        contact: 'Contact Us'}}},
  pa: {
    navbar: {
      logo: 'ਗੁਰਸਿੱਖ ਸਭਾ ਕੈਨਕੁਨ',
      links: ['ਦ੍ਰਿਸ਼ਟੀਕੋਣ', 'ਸਮਰਥਨ', 'ਭਾਈਵਾਲ', 'ਸਵਾਲ'],
      donateCta: 'ਆਪਣਾ ਆਨੰਦ ਕਾਰਜ ਬੁੱਕ ਕਰੋ'},
    hero: {
      headline1: 'ਕੈਨਕੁਨ ਲਈ ਇੱਕ ਗੁਰਦੁਆਰਾ।',
      headline2: 'ਪੀੜ੍ਹੀਆਂ ਲਈ ਇੱਕ ਵਿਰਾਸਤ।',
      subheadline:
        'ਜਿਵੇਂ-ਜਿਵੇਂ ਮੈਕਸੀਕੋ ਵਿੱਚ ਪੰਜਾਬੀ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਵਧ ਰਹੇ ਹਨ, ਕੈਨਕੁਨ ਨੂੰ ਇੱਕ ਸੱਚੇ ਅਧਿਆਤਮਿਕ ਘਰ ਦੀ ਲੋੜ ਹੈ — ਇੱਕ ਗੁਰਦੁਆਰਾ ਜੋ ਪਰਿਵਾਰਾਂ ਦੀ ਸੇਵਾ ਕਰੇ, ਪਵਿੱਤਰ ਰਸਮਾਂ ਦਾ ਸਮਰਥਨ ਕਰੇ, ਯਾਤਰੀਆਂ ਦਾ ਸਵਾਗਤ ਕਰੇ, ਅਤੇ ਸੰਗਤ, ਸੇਵਾ ਅਤੇ ਭਾਈਚਾਰੇ ਦਾ ਸਥਾਈ ਕੇਂਦਰ ਬਣੇ।',
      cta1: 'ਕੈਨਕੁਨ ਵਿੱਚ ਆਪਣਾ ਆਨੰਦ ਕਾਰਜ ਬੁੱਕ ਕਰੋ',
      cta2: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ',
      scrollIndicator: 'ਖੋਜੋ'},
    theNeed: {
      title1: 'ਲੋੜ ਅਸਲੀ ਹੈ।',
      title2: 'ਸਮਾਂ ਹੁਣ ਹੈ।',
      description:
        'ਜਦੋਂ ਕਿ ਕੈਨਕੂਨ ਪੰਜਾਬੀ ਵਿਆਹਾਂ ਅਤੇ ਪਰਿਵਾਰਕ ਯਾਤਰਾਵਾਂ ਲਈ ਇੱਕ ਪ੍ਰਮੁੱਖ ਸਥਾਨ ਬਣ ਗਿਆ ਹੈ, ਇੱਥੇ ਜ਼ਰੂਰੀ ਅਧਿਆਤਮਿਕ ਬੁਨਿਆਦੀ ਢਾਂਚੇ ਦੀ ਘਾਟ ਹੈ। ਜੋੜਿਆਂ, ਮਾਪਿਆਂ ਅਤੇ ਦਾਦਾ-ਦਾਦੀ ਨੂੰ ਪ੍ਰਾਰਥਨਾ, ਆਨੰਦ ਕਾਰਜ ਸਮਾਗਮਾਂ ਅਤੇ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ ਲਈ ਇੱਕ ਭਰੋਸੇਯੋਗ ਸਥਾਨ ਦੀ ਲੋੜ ਹੈ। ਇਹ ਇੱਕ ਮਹੱਤਵਪੂਰਨ ਘਾਟ ਹੈ ਜਿਸ ਨੂੰ ਸਾਨੂੰ ਪੂਰਾ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ।',
      imageCaption:
        "ਆਨੰਦ ਕਾਰਜ ਸੈਂਟਰ ਵਿੱਚ ਇੱਕ ਸ਼ਾਨਦਾਰ, ਢੱਕਿਆ ਹੋਇਆ ਬਾਹਰੀ ਪ੍ਰਵੇਸ਼ ਦੁਆਰ ਹੈ ਜੋ ਵਿਸ਼ੇਸ਼ ਤੌਰ 'ਤੇ ਰਵਾਇਤੀ ਵਿਆਹ ਦੀਆਂ ਬਰਾਤਾਂ ਦੇ ਅਨੁਕੂਲ ਹੋਣ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ। ਵਿਸ਼ਾਲ ਖਾਕਾ ਇਹ ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹੈ ਕਿ ਪਰਿਵਾਰ ਪਵਿੱਤਰ ਸਥਾਨ ਵਿੱਚ ਦਾਖਲ ਹੋਣ ਤੋਂ ਪਹਿਲਾਂ ਇੱਕ ਸਨਮਾਨਜਨਕ ਅਤੇ ਸਤਿਕਾਰਯੋਗ ਮਾਹੌਲ ਬਣਾਈ ਰੱਖਦੇ ਹੋਏ ਖੁਸ਼ੀ ਨਾਲ ਜਸ਼ਨ ਮਨਾ ਸਕਦੇ ਹਨ।",
      stats: [
        { number: '250–500', label: 'ਸਾਲਾਨਾ ਪੰਜਾਬੀ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ' },
        { number: 'ਜ਼ੀਰੋ', label: 'ਕੈਨਕੁਨ ਵਿੱਚ ਸਮਰਪਿਤ ਗੁਰਦੁਆਰੇ' },
        { number: 'ਵਿਸ਼ਵ', label: 'ਸਿੱਖ ਪਰਿਵਾਰਾਂ ਦੀ ਮੰਗ ਵਧ ਰਹੀ ਹੈ' }]},
    whyCancun: {
      title: 'ਕੈਨਕੁਨ ਕਿਉਂ?',
      description:
        'ਕੈਨਕੁਨ ਸਿਰਫ਼ ਇੱਕ ਸੁੰਦਰ ਥਾਂ ਨਹੀਂ ਹੈ; ਇਹ ਇੱਕ ਰਣਨੀਤਕ ਚੌਰਾਹਾ ਹੈ। ਜਿਵੇਂ ਹਜ਼ਾਰਾਂ ਸਿੱਖ ਪਰਿਵਾਰ ਹਰ ਸਾਲ ਜਸ਼ਨਾਂ ਅਤੇ ਛੁੱਟੀਆਂ ਲਈ ਇੱਥੇ ਆਉਂਦੇ ਹਨ, ਇੱਥੇ ਗੁਰਦੁਆਰਾ ਸਥਾਪਿਤ ਕਰਨਾ ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹੈ ਕਿ ਸਾਡੀਆਂ ਅਧਿਆਤਮਿਕ ਜੜ੍ਹਾਂ ਸਾਡੇ ਨਾਲ ਸਫ਼ਰ ਕਰਨ।',
      points: [
        {
          title: 'ਪ੍ਰਮੁੱਖ ਡੈਸਟੀਨੇਸ਼ਨ ਹੱਬ',
          desc: 'ਅਮਰੀਕਾ ਵਿੱਚ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਦਾ ਕੇਂਦਰ।'},
        {
          title: 'ਅੰਤਰਰਾਸ਼ਟਰੀ ਪਹੁੰਚ',
          desc: 'ਕੈਨੇਡਾ, ਅਮਰੀਕਾ ਅਤੇ ਵਿਸ਼ਵ ਭਰ ਤੋਂ ਸਿੱਧੀਆਂ ਉਡਾਣਾਂ।'},
        {
          title: 'ਵਿਸ਼ਵ-ਪੱਧਰੀ ਬੁਨਿਆਦੀ ਢਾਂਚਾ',
          desc: 'ਵੱਡੇ ਸਮਾਗਮਾਂ ਦਾ ਸਮਰਥਨ ਕਰਨ ਲਈ ਬੇਮਿਸਾਲ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਵਾਤਾਵਰਣ।'},
        {
          title: 'ਕੁਦਰਤੀ ਐਂਕਰ ਪੁਆਇੰਟ',
          desc: 'ਸਿੱਖ ਅਧਿਆਤਮਿਕ ਮੌਜੂਦਗੀ ਸਥਾਪਿਤ ਕਰਨ ਲਈ ਰਣਨੀਤਕ ਸਥਾਨ।'},
        {
          title: 'ਇੱਕ ਇਤਿਹਾਸਕ ਮੌਕਾ',
          desc: 'ਪਵਿੱਤਰ ਪਰੰਪਰਾ ਅਤੇ ਖੰਡੀ ਸ਼ਾਨ ਨੂੰ ਜੋੜਨ ਵਾਲਾ ਨਿਸ਼ਾਨ ਬਣਾਉਣ ਦਾ ਮੌਕਾ।'}]},
    ourVision: {
      title: 'ਸਾਡਾ ਦ੍ਰਿਸ਼ਟੀਕੋਣ',
      subtitle: 'ਪੜਾਵਾਂ ਵਿੱਚ ਉਸਾਰੀ। ਮਕਸਦ ਨਾਲ ਵਿਕਾਸ।',
      phases: [
        {
          num: '01',
          title: 'ਸਥਾਪਨਾ',
          desc: 'ਰੋਜ਼ਾਨਾ ਪ੍ਰਾਰਥਨਾ, ਆਨੰਦ ਕਾਰਜ ਸਹਾਇਤਾ, ਅਤੇ ਯਾਤਰੀਆਂ ਲਈ ਸਵਾਗਤੀ ਥਾਂ ਨਾਲ ਭਾਈਚਾਰੇ ਦੀ ਸੇਵਾ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਇੱਕ ਸਮਰਪਿਤ ਯੂਨਿਟ ਲੀਜ਼ ਤੇ ਲਓ।'},
        {
          num: '02',
          title: 'ਵਿਕਾਸ',
          desc: 'ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ, ਲੰਗਰ ਅਤੇ ਵੱਡੇ ਭਾਈਚਾਰਕ ਇਕੱਠਾਂ ਲਈ ਸਮਰੱਥਾ ਵਧਾਉਂਦੇ ਹੋਏ ਇੱਕ ਸੁੰਦਰ, ਪੂਰੀ ਤਰ੍ਹਾਂ ਕਾਰਜਸ਼ੀਲ ਗੁਰਦੁਆਰਾ ਘਰ ਬਣਾਓ।'},
        {
          num: '03',
          title: 'ਨਿਸ਼ਾਨ',
          desc: 'ਕੈਨਕੁਨ ਵਿੱਚ ਇੱਕ ਸਥਾਈ, ਸਰਵੋਤਮ ਆਰਕੀਟੈਕਚਰਲ ਨਿਸ਼ਾਨ ਸਥਾਪਿਤ ਕਰੋ ਜੋ ਪੀੜ੍ਹੀਆਂ ਲਈ ਸਿੱਖ ਵਿਰਾਸਤ ਦੀ ਰੌਸ਼ਨੀ ਬਣੇ।'}]},
    globalNetwork: {
      title1: 'ਇੱਕ',
      title2: 'ਵਿਸ਼ਵ ਨੈੱਟਵਰਕ ਦੁਆਰਾ ਸਮਰਥਿਤ',
      description:
        'ਇਹ ਪਹਿਲਕਦਮੀ ਸਤਿਕਾਰਤ ਸਿੱਖ ਪਰਿਵਾਰਾਂ, ਤਜਰਬੇਕਾਰ ਗੁਰਦੁਆਰਾ ਨਿਰਮਾਤਾਵਾਂ, ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਪੇਸ਼ੇਵਰਾਂ ਅਤੇ ਦੁਨੀਆ ਭਰ ਦੇ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਮਾਹਿਰਾਂ ਦੁਆਰਾ ਸਮਰਥਿਤ ਹੈ।',
      noteHighlight: 'ਮਹੱਤਵਪੂਰਨ:',
      note: 'ਪ੍ਰਤੀਬੱਧ ਪੂੰਜੀ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ। ਇਸ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਨੂੰ ਪੂਰੀ ਤਰ੍ਹਾਂ ਸਾਕਾਰ ਕਰਨ ਲਈ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ।',
      locations: ['ਸਿੰਗਾਪੁਰ', 'ਭਾਰਤ', 'ਕੈਨੇਡਾ', 'ਨਿਊਯਾਰਕ', 'ਅਤੇ ਹੋਰ']},
    weddingEcosystem: {
      eyebrow: 'ਵਿਆਹ ਦੇ ਈਕੋਸਿਸਟਮ ਲਈ',
      title: 'ਇੱਕ ਰਣਨੀਤਕ ਭਾਈਵਾਲੀ ਦਾ ਮੌਕਾ',
      imageCaption:
        "ਆਨੰਦ ਕਾਰਜ ਸੈਂਟਰ ਵਿੱਚ ਇੱਕ ਸ਼ਾਨਦਾਰ, ਢੱਕਿਆ ਹੋਇਆ ਬਾਹਰੀ ਪ੍ਰਵੇਸ਼ ਦੁਆਰ ਹੈ ਜੋ ਵਿਸ਼ੇਸ਼ ਤੌਰ 'ਤੇ ਰਵਾਇਤੀ ਵਿਆਹ ਦੀਆਂ ਬਰਾਤਾਂ ਦੇ ਅਨੁਕੂਲ ਹੋਣ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ। ਵਿਸ਼ਾਲ ਖਾਕਾ ਇਹ ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹੈ ਕਿ ਪਰਿਵਾਰ ਪਵਿੱਤਰ ਸਥਾਨ ਵਿੱਚ ਦਾਖਲ ਹੋਣ ਤੋਂ ਪਹਿਲਾਂ ਇੱਕ ਸਨਮਾਨਜਨਕ ਅਤੇ ਸਤਿਕਾਰਯੋਗ ਮਾਹੌਲ ਬਣਾਈ ਰੱਖਦੇ ਹੋਏ ਖੁਸ਼ੀ ਨਾਲ ਜਸ਼ਨ ਮਨਾ ਸਕਦੇ ਹਨ।",
      description:
        'ਅਸੀਂ ਡੈਸਟੀਨੇਸ਼ਨ ਵੈਡਿੰਗ ਪਲਾਨਰਾਂ, ਪਰਾਹੁਣਚਾਰੀ ਪੇਸ਼ੇਵਰਾਂ ਅਤੇ ਉਦਯੋਗ ਦੇ ਨੇਤਾਵਾਂ ਨੂੰ ਸਾਡੇ ਨਾਲ ਜੁੜਨ ਲਈ ਸੱਦਾ ਦੇ ਰਹੇ ਹਾਂ। ਕੈਨਕੂਨ ਗੁਰਦੁਆਰਾ ਨਾਲ ਭਾਈਵਾਲੀ ਕਰਕੇ, ਤੁਸੀਂ ਇਹ ਯਕੀਨੀ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰਦੇ ਹੋ ਕਿ ਤੁਹਾਡੇ ਗਾਹਕਾਂ ਦੀ ਇੱਕ ਭਰੋਸੇਯੋਗ ਸਮਾਰੋਹ ਸਥਾਨ, ਪਰਿਵਾਰਕ ਪਰਾਹੁਣਚਾਰੀ, ਅਤੇ ਅਧਿਆਤਮਿਕ ਬੁਨਿਆਦੀ ਢਾਂਚੇ ਤੱਕ ਪਹੁੰਚ ਹੋਵੇ ਜਿਸਦੀ ਉਹਨਾਂ ਨੂੰ ਇੱਕ ਸੰਪੂਰਨ ਆਨੰਦ ਕਾਰਜ ਲਈ ਲੋੜ ਹੈ।',
      plannerNote:
        'ਪ੍ਰਮੁੱਖ ਯੋਜਨਾਕਾਰਾਂ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ ਜੋ ਪਹਿਲਾਂ ਹੀ ਇਸ ਇਤਿਹਾਸਕ ਪਹਿਲਕਦਮੀ ਦਾ ਸਮਰਥਨ ਕਰ ਰਹੇ ਹਨ।',
      cta: 'ਗੁਰਦੁਆਰਾ ਬੁੱਕ ਕਰੋ'},
    weddingDateInquiry: {
      title: 'ਆਪਣੇ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਦੀ ਯੋਜਨਾ ਬਣਾ ਰਹੇ ਹੋ?',
      subtitle:
        'ਉਪਲਬਧਤਾ ਦੀ ਜਾਂਚ ਕਰੋ ਅਤੇ ਪਤਾ ਕਰੋ ਕਿ ਕੀ ਕੈਨਕੂਨ ਗੁਰਦੁਆਰਾ ਤੁਹਾਡੇ ਖਾਸ ਦਿਨ ਦਾ ਸਮਰਥਨ ਕਰ ਸਕਦਾ ਹੈ।',
      description:
        'ਭਾਵੇਂ ਤੁਸੀਂ ਕੈਨਕੂਨ ਵਿੱਚ ਆਨੰਦ ਕਾਰਜ ਦੀ ਯੋਜਨਾ ਬਣਾ ਰਹੇ ਹੋ ਜਾਂ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਦੇ ਵਿਕਲਪਾਂ ਦੀ ਪੜਚੋਲ ਕਰ ਰਹੇ ਹੋ, ਸਿੱਧਾ ਸਾਡੀ ਟੀਮ ਨਾਲ ਸੰਪਰਕ ਕਰੋ। ਅਸੀਂ ਸਮਾਂ-ਸੀਮਾਵਾਂ, ਉਪਲਬਧਤਾ, ਅਤੇ ਅਸੀਂ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦਾ ਕਿਵੇਂ ਸਮਰਥਨ ਕਰ ਸਕਦੇ ਹਾਂ, ਇਹ ਸਮझਣ ਵਿੱਚ ਤੁਹਾਡੀ ਮਦਦ ਕਰਾਂਗੇ।',
      cta: 'ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ'},
    whatThisMakesPossible: {
      title1: 'ਇਹ ਕੀ',
      title2: 'ਸੰਭਵ ਬਣਾਉਂਦਾ ਹੈ',
      features: [
        {
          title: 'ਆਨੰਦ ਕਾਰਜ ਸਹਾਇਤਾ',
          desc: 'ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਲਈ ਸਮਰਪਿਤ, ਪਵਿੱਤਰ ਥਾਂ।'},
        {
          title: 'ਰੋਜ਼ਾਨਾ ਪ੍ਰਾਰਥਨਾ ਅਤੇ ਸੰਗਤ',
          desc: 'ਸਥਾਨਕ ਅਤੇ ਯਾਤਰੀਆਂ ਲਈ ਨਿਰੰਤਰ ਅਧਿਆਤਮਿਕ ਪਹੁੰਚ।'},
        {
          title: 'ਪਰਿਵਾਰਕ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ',
          desc: 'ਲੰਗਰ ਦੀ ਪਰੰਪਰਾ ਵਿੱਚ ਜੜ੍ਹਿਆ ਸਵਾਗਤੀ ਮਾਹੌਲ।'},
        {
          title: 'ਬਜ਼ੁਰਗ ਅਤੇ ਯਾਤਰੀ ਸਵਾਗਤ',
          desc: 'ਮਿਲਣ ਆਉਣ ਵਾਲੇ ਪਰਿਵਾਰਾਂ ਲਈ ਘਰ ਅਤੇ ਆਰਾਮ ਦੀ ਭਾਵਨਾ।'},
        {
          title: 'ਭਰੋਸੇਯੋਗ ਢਾਂਚਾ',
          desc: 'ਗੁੰਝਲਦਾਰ ਡੈਸਟੀਨੇਸ਼ਨ ਸਮਾਗਮਾਂ ਲਈ ਭਰੋਸੇਯੋਗ ਸਹਾਇਤਾ।'},
        {
          title: 'ਪੀੜ੍ਹੀਆਂ ਲਈ ਨਿਸ਼ਾਨ',
          desc: 'ਅਮਰੀਕਾ ਵਿੱਚ ਸਿੱਖ ਮੌਜੂਦਗੀ ਦੀ ਵਿਰਾਸਤ ਬਣਾਉਣਾ।'}]},
    fundingPathways: {
      title: 'ਕੈਨਕੁਨ ਗੁਰਦੁਆਰੇ ਦਾ ਸਮਰਥਨ ਕਰੋ',
      subtitle:
        'ਹਰ ਯੋਗਦਾਨ ਇਸ ਇਤਿਹਾਸਕ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਨੂੰ ਹਕੀਕਤ ਦੇ ਨੇੜੇ ਲਿਆਉਂਦਾ ਹੈ।',
      donateFrom: 'ਤੋਂ ਦਾਨ ਕਰੋ',
      comingSoon: 'ਲਿੰਕ ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ',
      opportunities: [
        'ਸੰਸਥਾਪਕ ਦਾਨੀ ਮੌਕੇ',
        'ਪਰਿਵਾਰਕ ਸਪਾਂਸਰਸ਼ਿਪ',
        'ਕਾਰਪੋਰੇਟ / ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਸਮਰਥਕ'],
      inquireCta: 'ਹੁਣੇ ਪੁੱਛਗਿੱਛ ਕਰੋ'},
    foundingCircle: {
      title1: 'ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ',
      title2: 'ਸੰਸਥਾਪਕ ਸਰਕਲ',
      description:
        'ਇਹ ਇੱਕ ਪੀੜ੍ਹੀ ਵਿੱਚ ਇੱਕ ਵਾਰ ਮਿਲਣ ਵਾਲਾ ਮੌਕਾ ਹੈ ਇੱਕ ਅਧਿਆਤਮਿਕ ਘਰ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰਨ ਦਾ ਜੋ ਦਹਾਕਿਆਂ ਤੱਕ ਪਰਿਵਾਰਾਂ ਦੀ ਸੇਵਾ ਕਰੇਗਾ। ਤੁਹਾਡਾ ਨਾਮ। ਤੁਹਾਡਾ ਪਰਿਵਾਰ। ਇਤਿਹਾਸ ਦਾ ਹਿੱਸਾ।',
      cta: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ'},
    faq: {
      title: 'ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ',
      questions: [
        {
          q: 'ਗੁਰਦੁਆਰਾ ਕਿੱਥੇ ਸਥਿਤ ਹੋਵੇਗਾ?',
          a: 'ਅਸੀਂ ਕੈਨਕੂਨ ਵਿੱਚ ਕਈ ਕੇਂਦਰੀ ਸਥਾਨਾਂ ਦਾ ਮੁਲਾਂਕਣ ਕਰ ਰਹੇ ਹਾਂ ਜੋ ਹੋਟਲ ਜ਼ੋਨ ਅਤੇ ਹਵਾਈ ਅੱਡੇ ਤੋਂ ਆਸਾਨ ਪਹੁੰਚ ਦੀ ਪੇਸ਼ਕਸ਼ ਕਰਦੇ ਹਨ।'},
        {
          q: 'ਇਹ ਕਦੋਂ ਖੁੱਲ੍ਹੇਗਾ?',
          a: 'ਪੜਾਅ 1 (ਸਥਾਪਿਤ ਕਰਨਾ) 2024 ਦੇ ਅਖੀਰ ਲਈ ਨਿਸ਼ਾਨਾ ਹੈ, ਜੋ ਆਨੰਦ ਕਾਰਜ ਸਮਾਗਮਾਂ ਲਈ ਤੁਰੰਤ ਸਹਾਇਤਾ ਪ੍ਰਦਾਨ ਕਰੇਗਾ।'},
        {
          q: 'ਮੈਂ ਆਨੰਦ ਕਾਰਜ ਕਿਵੇਂ ਬੁੱਕ ਕਰ ਸਕਦਾ ਹਾਂ?',
          a: 'ਸਾਡੀ ਟੀਮ ਨਾਲ ਤਾਰੀਖਾਂ ਅਤੇ ਉਪਲਬਧਤਾ ਦੀ ਜਾਂਚ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਉੱਪਰ ਦਿੱਤੇ ਪੁੱਛਗਿੱਛ ਫਾਰਮ ਦੀ ਵਰਤੋਂ ਕਰੋ।'}]},
    stickyMobileCta: {
      text: 'ਆਪਣਾ ਆਨੰਦ ਕਾਰਜ ਬੁੱਕ ਕਰੋ'},
    finalCta: {
      headline1: 'ਪੀੜ੍ਹੀਆਂ ਲਈ',
      headline2: 'ਇੱਕ ਵਿਰਾਸਤ।',
      cta1: 'ਆਪਣਾ ਆਨੰਦ ਕਾਰਜ ਬੁੱਕ ਕਰੋ',
      cta2: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ',
      copyright: '© 2024 ਗੁਰਸਿੱਖ ਸਭਾ ਕੈਨਕੁਨ। ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।',
      pitchDeck: 'ਪਿੱਚ ਡੈੱਕ',
      contact: 'ਸੰਪਰਕ',
      inquiries: 'ਪੁੱਛਗਿੱਛ',
      privacy: 'ਪਰਦੇਦਾਰੀ'},
    pitchDeck: {
      backToHome: 'ਮੁੱਖ ਪੰਨੇ ਤੇ ਵਾਪਸ ਜਾਓ',
      cover: {
        title: 'ਗੁਰਸਿੱਖ ਸਭਾ ਕੈਨਕੁਨ',
        subtitle: 'ਕੈਨਕੁਨ ਦਾ ਪਹਿਲਾ ਗੁਰਦੁਆਰਾ ਬਣਾਉਣਾ',
        description:
          'ਅਮਰੀਕਾ ਦੇ ਪ੍ਰਮੁੱਖ ਡੈਸਟੀਨੇਸ਼ਨ ਹੱਬ ਵਿੱਚ ਗਲੋਬਲ ਸਿੱਖ ਭਾਈਚਾਰੇ ਲਈ ਇੱਕ ਸਥਾਈ ਅਧਿਆਤਮਿਕ ਘਰ ਸਥਾਪਤ ਕਰਨ ਲਈ ਇੱਕ ਰਣਨੀਤਕ ਪਹਿਲਕਦਮੀ।'},
      sacredNeed: {
        title: 'ਪਵਿੱਤਰ ਲੋੜ',
        subtitle: 'ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਲਈ ਸਤਿਕਾਰ ਬਹਾਲ ਕਰਨਾ',
        description:
          'ਵਰਤਮਾਨ ਵਿੱਚ, ਕੈਨਕੁਨ ਵਿੱਚ ਆਨੰਦ ਕਾਰਜ ਹੋਟਲ ਦੇ ਬਾਲਰੂਮਾਂ ਅਤੇ ਰਿਜ਼ੋਰਟਾਂ ਵਿੱਚ ਹੁੰਦੇ ਹਨ। ਇੱਕ ਸਮਰਪਿਤ ਅਧਿਆਤਮਿਕ ਸਥਾਨ ਤੋਂ ਬਿਨਾਂ, ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਲਈ ਉੱਚ ਪੱਧਰੀ ਮਰਯਾਦਾ ਅਤੇ ਸਤਿਕਾਰ ਬਣਾਈ ਰੱਖਣਾ ਇੱਕ ਨਿਰੰਤਰ ਚੁਣੌਤੀ ਹੈ। ਸਾਨੂੰ ਇੱਕ ਸ਼ੁੱਧ, ਸਮਰਪਿਤ ਅਸਥਾਨ ਦੀ ਲੋੜ ਹੈ ਜਿੱਥੇ ਮਹਾਰਾਜ ਨੂੰ ਸਾਡੇ ਵਿਸ਼ਵਾਸ ਦੀ ਮੰਗ ਅਨੁਸਾਰ ਪੂਰਨ ਸਤਿਕਾਰ ਨਾਲ ਬਿਰਾਜਮਾਨ ਕੀਤਾ ਜਾ ਸਕੇ।'},
      opportunity: {
        title: 'ਮੌਕਾ',
        description:
          'ਕੈਨਕੁਨ ਤੇਜ਼ੀ ਨਾਲ ਪੰਜਾਬੀ ਵਿਆਹਾਂ ਅਤੇ ਪਰਿਵਾਰਕ ਯਾਤਰਾਵਾਂ ਲਈ ਇੱਕ ਪ੍ਰਮੁੱਖ ਮੰਜ਼ਿਲ ਬਣ ਗਿਆ ਹੈ, ਫਿਰ ਵੀ ਇੱਥੇ ਜ਼ਰੂਰੀ ਅਧਿਆਤਮਿਕ ਢਾਂਚੇ ਦੀ ਘਾਟ ਹੈ। ਇਹ ਇੱਕ ਇਤਿਹਾਸਕ ਸੰਸਥਾ ਬਣਾਉਣ ਦਾ ਇੱਕ ਵਿਲੱਖਣ ਮੌਕਾ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।',
        stats: [
          { number: '250–500', label: 'ਸਾਲਾਨਾ ਪੰਜਾਬੀ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ' },
          { number: 'ਜ਼ੀਰੋ', label: 'ਅੱਜ ਕੈਨਕੁਨ ਵਿੱਚ ਸਮਰਪਿਤ ਗੁਰਦੁਆਰੇ' },
          {
            number: 'ਗਲੋਬਲ',
            label: 'ਸਿੱਖ ਪਰਿਵਾਰਾਂ ਦੀ ਮੰਗ ਤੇਜ਼ੀ ਨਾਲ ਵੱਧ ਰਹੀ ਹੈ'}]},
      whyCancun: {
        title: 'ਕੈਨਕੁਨ ਕਿਉਂ?',
        points: [
          {
            title: 'ਪ੍ਰਮੁੱਖ ਡੈਸਟੀਨੇਸ਼ਨ ਹੱਬ',
            desc: 'ਅਮਰੀਕਾ ਵਿੱਚ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਦਾ ਕੇਂਦਰ।'},
          {
            title: 'ਅੰਤਰਰਾਸ਼ਟਰੀ ਪਹੁੰਚ',
            desc: 'ਵਿਸ਼ਵ ਪੱਧਰ ਤੇ ਪ੍ਰਮੁੱਖ ਹੱਬਾਂ ਤੋਂ ਸਿੱਧੀਆਂ ਉਡਾਣਾਂ।'},
          {
            title: 'ਵਿਸ਼ਵ ਪੱਧਰੀ ਬੁਨਿਆਦੀ ਢਾਂਚਾ',
            desc: 'ਬੇਮਿਸਾਲ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਈਕੋਸਿਸਟਮ।'},
          {
            title: 'ਰਣਨੀਤਕ ਸਥਾਨ',
            desc: 'ਇੱਕ ਸਥਾਈ ਸਿੱਖ ਮੌਜੂਦਗੀ ਲਈ ਇੱਕ ਕੁਦਰਤੀ ਐਂਕਰ ਪੁਆਇੰਟ।'}]},
      reality: {
        title: 'ਅਸਲੀਅਤ',
        subtitle: 'ਇੱਕ ਪ੍ਰਵਾਸੀ-ਫੰਡਿਡ ਮਿਸ਼ਨ',
        description:
          'ਇਸ ਗੁਰਦੁਆਰੇ ਨੂੰ ਫੰਡ ਦੇਣ ਅਤੇ ਕਾਇਮ ਰੱਖਣ ਲਈ ਕੈਨਕੁਨ ਜਾਂ ਮੈਕਸੀਕੋ ਵਿੱਚ ਕੋਈ ਸਥਾਪਤ ਸਥਾਨਕ ਸਿੱਖ ਭਾਈਚਾਰਾ ਨਹੀਂ ਹੈ। ਅਸੀਂ 100% ਅਮਰੀਕੀ ਅਤੇ ਕੈਨੇਡੀਅਨ ਪ੍ਰਵਾਸੀਆਂ ਤੇ ਨਿਰਭਰ ਕਰਦੇ ਹਾਂ। ਜੇਕਰ ਅਸੀਂ ਚਾਹੁੰਦੇ ਹਾਂ ਕਿ ਸਾਡੇ ਪਰਿਵਾਰਾਂ ਅਤੇ ਆਉਣ ਵਾਲੀਆਂ ਪੀੜ੍ਹੀਆਂ ਦਾ ਕੈਨਕੁਨ ਵਿੱਚ ਸਹੀ ਆਨੰਦ ਕਾਰਜ ਹੋਵੇ, ਤਾਂ ਸਾਨੂੰ—ਪ੍ਰਵਾਸੀਆਂ ਨੂੰ—ਇਸਨੂੰ ਖੁਦ ਬਣਾਉਣਾ ਪਵੇਗਾ।'},
      vision: {
        title: 'ਸਾਡਾ ਦ੍ਰਿਸ਼ਟੀਕੋਣ',
        subtitle: 'ਪੜਾਵਾਂ ਵਿੱਚ ਬਣਾਉਣਾ। ਉਦੇਸ਼ ਨਾਲ ਵਧਣਾ।',
        phases: [
          {
            num: '01',
            title: 'ਸਥਾਪਿਤ ਕਰੋ',
            desc: 'ਰੋਜ਼ਾਨਾ ਪ੍ਰਾਰਥਨਾ ਅਤੇ ਆਨੰਦ ਕਾਰਜ ਲਈ ਇੱਕ ਸਮਰਪਿਤ ਜਗ੍ਹਾ ਲੀਜ਼ ਤੇ ਲਓ।'},
          {
            num: '02',
            title: 'ਵਧੋ',
            desc: 'ਲੰਗਰ ਸਹੂਲਤਾਂ ਦੇ ਨਾਲ ਇੱਕ ਪੂਰੀ ਤਰ੍ਹਾਂ ਕਾਰਜਸ਼ੀਲ ਗੁਰਦੁਆਰਾ ਬਣਾਓ।'},
          {
            num: '03',
            title: 'ਲੈਂਡਮਾਰਕ',
            desc: 'ਕੈਨਕੁਨ ਵਿੱਚ ਇੱਕ ਸਥਾਈ ਆਰਕੀਟੈਕਚਰਲ ਲੈਂਡਮਾਰਕ ਸਥਾਪਤ ਕਰੋ।'}]},
      ecosystem: {
        title: 'ਵਿਆਹ ਈਕੋਸਿਸਟਮ',
        description:
          'ਗੁਰਦੁਆਰਾ ਕੈਨਕੁਨ ਦੇ ਵਧ ਰਹੇ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਬਾਜ਼ਾਰ ਦਾ ਇੱਕ ਮਹੱਤਵਪੂਰਨ ਹਿੱਸਾ ਬਣ ਜਾਵੇਗਾ, ਸਿੱਖ ਪਰਿਵਾਰਾਂ ਲਈ ਪ੍ਰਮਾਣਿਕ ਅਧਿਆਤਮਿਕ ਢਾਂਚਾ ਪ੍ਰਦਾਨ ਕਰਨ ਲਈ ਯੋਜਨਾਕਾਰਾਂ, ਰਿਜ਼ੋਰਟਾਂ ਅਤੇ ਵਿਕਰੇਤਾਵਾਂ ਦੇ ਨਾਲ ਨਿਰਵਿਘਨ ਕੰਮ ਕਰੇਗਾ।'},
      network: {
        title: 'ਗਲੋਬਲ ਨੈੱਟਵਰਕ',
        description:
          'ਦੁਨੀਆ ਭਰ ਦੇ ਸਤਿਕਾਰਤ ਪਰਿਵਾਰਾਂ, ਤਜਰਬੇਕਾਰ ਬਿਲਡਰਾਂ ਅਤੇ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਪੇਸ਼ੇਵਰਾਂ ਦੇ ਗੱਠਜੋੜ ਦੁਆਰਾ ਸਮਰਥਿਤ।',
        locations: ['ਸਿੰਗਾਪੁਰ', 'ਭਾਰਤ', 'ਕੈਨੇਡਾ', 'ਨਿਊਯਾਰਕ', 'ਅਤੇ ਹੋਰ']},
      financial: {
        title: 'ਵਿੱਤੀ ਬੇਨਤੀ',
        description:
          'ਸ਼ੁਰੂਆਤੀ ਪੂੰਜੀ ਸਾਡੇ ਸੰਸਥਾਪਕ ਸਮੂਹ ਦੁਆਰਾ ਪ੍ਰਤੀਬੱਧ ਕੀਤੀ ਗਈ ਹੈ। ਅਸੀਂ ਹੁਣ ਆਪਣੀ ਲੀਜ਼ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰਨ, ਪੜਾਅ 1 ਦੇ ਸੰਚਾਲਨ ਨੂੰ ਫੰਡ ਦੇਣ, ਅਤੇ ਲੰਬੇ ਸਮੇਂ ਦੀ ਸਥਿਰਤਾ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ ਉੱਤਰੀ ਅਮਰੀਕਾ ਭਰ ਤੋਂ ਵਿਆਪਕ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ ਦੀ ਮੰਗ ਕਰ ਰਹੇ ਹਾਂ।',
        tiers: [
          {
            title: 'ਸੰਸਥਾਪਕ ਸਰਕਲ',
            desc: 'ਬੁਨਿਆਦ ਨੂੰ ਆਕਾਰ ਦੇਣ ਵਾਲੇ ਪ੍ਰਮੁੱਖ ਦਾਨੀ।'},
          {
            title: 'ਪਰਿਵਾਰਕ ਸਪਾਂਸਰਸ਼ਿਪ',
            desc: 'ਖਾਸ ਸਹੂਲਤਾਂ ਜਾਂ ਪ੍ਰੋਗਰਾਮਾਂ ਨੂੰ ਸਪਾਂਸਰ ਕਰਨਾ।'},
          {
            title: 'ਕਾਰਪੋਰੇਟ ਸਮਰਥਕ',
            desc: 'ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਅਤੇ ਵਿਆਹ ਵਿਕਰੇਤਾਵਾਂ ਨਾਲ ਭਾਈਵਾਲੀ।'}]},
      cta: {
        title: 'ਸਾਡੇ ਨਾਲ ਜੁੜੋ',
        donate: 'ਆਪਣਾ ਆਨੰਦ ਕਾਰਜ ਬੁੱਕ ਕਰੋ',
        founding: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ',
        contact: 'ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ'}}}}